import { useTranslation } from 'react-i18next';
import { DateTimeInfo, type TimeInfo } from '../../date-time-info';
import { Text } from '../../typography';

export type DataCardDescriptionProperties = string | TimeInfo;

type P = {
  description: DataCardDescriptionProperties;
};

export const DataCardDescription = ({ description }: P) => {
  const { t } = useTranslation();

  if (typeof description === 'string') {
    return <Text size="small">{t(description)}</Text>;
  }

  return <DateTimeInfo fontSize="small" timeInfo={description} />;
};
